// Mantine
import { Button, Modal, NumberInput } from '@mantine/core'

import { notifications } from '@mantine/notifications'

import { useDisclosure } from '@mantine/hooks'

// React
import { useState } from 'react'

// UI
import ProductionOrderComplete from './ProductionOrderComplete'
import Box from '../ui/Box'
import SegmentedProgressBar from '../ui/SegmentedProgressBar'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

export default function ProductionOrderProgressBlock({
    productionOrder,
    onChanged,
}) {
    // Quantity Control Modal
    const [quantityControl, setQuantityControl] = useState(
        productionOrder.quantity_in_control
    )

    const [openedQuantityControl, handlersQuantityControl] =
        useDisclosure(false)

    const openQuantityControl = () => {
        setQuantityControl(productionOrder.quantity_in_control)
        handlersQuantityControl.open()
    }

    // Save
    const { requestPost } = useAxiosApi()

    const saveQuantityInControl = async () => {
        await requestPost(`/production-orders/${productionOrder.id}/update-control`, {
            quantity_in_control: quantityControl,
        })

        onChanged()
        handlersQuantityControl.close()

        notifications.show({
            title: 'Quantité en contrôle modifiée',
            message: 'La quantité en contrôle à été modifée',
            color: 'green',
        })
    }

    const total = productionOrder.quantity
    const completed = productionOrder.quantity_completed
    const inControl = productionOrder.quantity_in_control
    const remaining = total - completed - inControl

    const percentCompleted = Math.floor((completed / total) * 100)

    return (
        <Box title="Progression">
            {productionOrder.status === 'open' && (
                <div className="flex flex-col gap-5">
                    <div className="flex items-baseline gap-2">
                        <span className="text-2xl font-bold text-gray-900">
                            {percentCompleted}%
                        </span>
                        <span className="text-sm text-gray-500">
                            complété — {completed} / {total}
                        </span>
                    </div>

                    <div className="space-y-2">
                        <SegmentedProgressBar
                            segments={[
                                { value: (completed / total) * 100, color: 'bg-green-500' },
                                { value: (inControl / total) * 100, color: 'bg-orange-400' },
                                { value: (remaining / total) * 100, color: 'bg-gray-200' },
                            ]}
                            totalBars={24}
                        />

                        <div className="flex gap-4 text-xs text-gray-500">
                            <div className="flex items-center gap-1.5">
                                <div className="h-2.5 w-2.5 rounded-full bg-green-500" />
                                <span>Terminés ({completed})</span>
                            </div>
                            <div className="flex items-center gap-1.5">
                                <div className="h-2.5 w-2.5 rounded-full bg-orange-400" />
                                <span>En contrôle ({inControl})</span>
                            </div>
                            <div className="flex items-center gap-1.5">
                                <div className="h-2.5 w-2.5 rounded-full bg-gray-200" />
                                <span>Restants ({remaining})</span>
                            </div>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                        <Button variant="default" onClick={openQuantityControl}>
                            Modifier le contrôle qualité
                        </Button>

                        <ProductionOrderComplete
                            productionOrder={productionOrder}
                            onChanged={onChanged}
                        />
                    </div>
                </div>
            )}

            <Modal
                opened={openedQuantityControl}
                title="Quantité en contrôle qualité"
                onClose={handlersQuantityControl.close}
            >
                <div className="flex flex-col">
                    <NumberInput
                        value={quantityControl}
                        onChange={setQuantityControl}
                        label="Quantité en contrôle qualité"
                        min={0}
                    />

                    <div className="flex gap-1 mt-5 ml-auto">
                        <Button
                            variant="default"
                            onClick={handlersQuantityControl.close}
                        >
                            Annuler
                        </Button>

                        <Button onClick={saveQuantityInControl}>
                            Modifier la quantité
                        </Button>
                    </div>
                </div>
            </Modal>
        </Box>
    )
}
